import { all, call, put } from 'redux-saga/effects';
import { requestForSaga } from 'utils/request/request';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';
import { FETCH_VPN_STATUS, VPN_START, VPN_STOP } from './constants';

import { takeEvery } from 'containers/ErrorBoundary';

function* fetchStatusSaga() {
  try {
    yield put({ type: `${FETCH_VPN_STATUS}_START` });
    const status = yield call(requestForSaga, {
      url: '/support/vpn-status',
      method: 'GET',
    });
    yield put({
      type: `${FETCH_VPN_STATUS}_SUCCESS`,
      payload: { ...status },
    });
  } catch (e) {
    yield put({ type: `${FETCH_VPN_STATUS}_ERROR` });
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

const getGenerator = (constant, apiEndPoint) => {
  return function* connectVpn() {
    try {
      yield put({ type: `${constant}_START` });
      const status = yield call(requestForSaga, {
        url: apiEndPoint,
        method: 'GET',
      });
      yield put({
        type: `${constant}_SUCCESS`,
        payload: { ...status },
      });
    } catch (e) {
      yield put({ type: `${constant}_ERROR` });
      yield call(requestCustomErrorMessage, 'danger', e);
      throw e;
    }
  };
};

export function* defaultSaga() {
  yield all([
    takeEvery(FETCH_VPN_STATUS, fetchStatusSaga),
    takeEvery(VPN_START, getGenerator(VPN_START, '/support/vpn-start')),
    takeEvery(VPN_STOP, getGenerator(VPN_STOP, '/support/vpn-stop')),
  ]);
}

export default defaultSaga;
